import { z } from "zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { matchDollarAmountRE } from "@/constants/regex";

const clientApplyCreditSchema = z.object({
  mainCreditBalance: z.string().refine(
    (value) => {
      // Allow empty string or valid dollar amount
      if (value === "") return true;
      return matchDollarAmountRE.test(value);
    },
    {
      message: "Only numbers or decimals are allowed, Please check again.",
    },
  ),
  massageCreditBalance: z.string().refine(
    (value) => {
      // Allow empty string or valid dollar amount
      if (value === "") return true;
      return matchDollarAmountRE.test(value);
    },
    {
      message: "Only numbers or decimals are allowed, Please check again.",
    },
  ),
});

export type ClientApplyCreditFormData = z.input<typeof clientApplyCreditSchema>;

export interface ClientApplyCreditFormReturn
  extends UseFormReturn<ClientApplyCreditFormData> {
  defaultValues: ClientApplyCreditFormData;
}

const initialFormValues: ClientApplyCreditFormData = {
  mainCreditBalance: "",
  massageCreditBalance: "",
};

export const useClientApplyCreditForm = (
  initialValues?: ClientApplyCreditFormData,
): ClientApplyCreditFormReturn => ({
  defaultValues: initialValues || initialFormValues,
  ...useForm<ClientApplyCreditFormData>({
    mode: "onChange",
    defaultValues: initialValues,
    resolver: zodResolver(clientApplyCreditSchema),
  }),
});
